import React, { useState, useRef } from 'react'
import { Link } from 'react-router-dom'
import Hero from '../Components/Hero/Hero'
import Carousel from '../Components/Carousel/Carousel';
import { boardGameProducts } from '../Components/Assets/Product_Info/boardGameProducts';
import { MTGProducts } from '../Components/Assets/Product_Info/MTGProducts';
import { OnePieceProduct } from '../Components/Assets/Product_Info/OnePieceProduct';
import { DragonShieldProducts } from '../Components/Assets/Product_Info/DragonShieldProducts';
import { LuckDragonProducts } from '../Components/Assets/Product_Info/LuckDragonProducts';
import { SleeveKingsProducts } from '../Components/Assets/Product_Info/SleeveKingsProducts';
import { ArmyPainterProducts } from '../Components/Assets/Product_Info/ArmyPainterProducts';
import { GradedGuardProducts } from '../Components/Assets/Product_Info/GradedGuardProducts';
import { DiceProducts } from '../Components/Assets/Product_Info/DiceProducts';
import './Home.css'
import './ContactUs.css'

const tcgProducts = [...MTGProducts, ...OnePieceProduct]
const tcgAccessoryProducts = [
  ...DragonShieldProducts,
  ...LuckDragonProducts,
  ...SleeveKingsProducts,
  ...ArmyPainterProducts,
  ...GradedGuardProducts,
  ...DiceProducts,
]

const stripHtml = (str) => {
  if (typeof str !== 'string') return ''
  return str.replace(/<[^>]*>/g, '').replace(/[<>]/g, '').trim()
}

const Home = () => {
  const formRef = useRef(null)
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')
  const [sending, setSending] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    const form = formRef.current
    const name = stripHtml(form.name.value)
    const email = stripHtml(form.email.value)
    const subject = stripHtml(form.subject.value)
    const message = stripHtml(form.message.value)

    if (!name || !email || !subject || !message) {
      setError('Please fill in all fields.')
      return
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Please enter a valid email address.')
      return
    }

    setSending(true)

    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email, subject, message }),
      })

      if (!res.ok) {
        const data = await res.json()
        throw new Error(data.error || 'Failed to send.')
      }

      setSent(true)
      form.reset()
    } catch {
      setError('Failed to send. Please try again later.')
    } finally {
      setSending(false)
    }
  }

  return (
    <div style={{background: '#fde1ff'}}>
      <Hero/>

      <div className='home-mission'>
        <h2>Our Mission</h2>
        <p>Tager's Shoppe was founded to bridge the gap. Every product we stock, from board games to card binders, are chosen not just for quality, but for the experiences they enable. We believe that the simple act of gathering around a table or playing a game can strengthen the bonds that hold us all together.</p>
       
      </div>

      <div className='home-mission'>
        <div className='home-refund-content'>
          <h2>Our Refund Policy</h2>
          <p>
            We want you to be completely satisfied with your purchase. If you're not happy with your product, you can return it within 14 days of delivery, provided it is undamaged, unused, and in its original packaging (In compliance with our refund policy).
          </p>
          <p>
            Products damaged on delivery or found to be defective can be returned within 3 months for a replacement or refund.
          </p>
          <Link to='/AboutUs#refund-policy' className='home-refund-link'>
            Read our full Refund Policy →
          </Link>
        </div>
      </div>

      <Carousel heading="Popular Board Games" data={boardGameProducts}/>

      <Carousel heading="Trading Card Games" data={tcgProducts}/>

      <Carousel heading="TCG Accessories" data={tcgAccessoryProducts}/>

      <div className='home-values'>
        <h2>Get in Touch</h2>

        {sent ? (
          <div className='contact-form' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center', padding: '60px 30px', maxWidth: 700, margin: '0 auto' }}>
            <h2>Thank you!</h2>
            <p style={{ color: '#555', fontSize: 16, lineHeight: 1.6 }}>Your message has been sent. We will get back to you as soon as possible.</p>
          </div>
        ) : (
          <form className='contact-form' ref={formRef} onSubmit={handleSubmit} style={{ maxWidth: 700, margin: '0 auto' }}>
            <h2>Send a Message</h2>

            <div style={{ display: 'flex', gap: 16 }}>
              <div style={{ flex: 1 }}>
                <label htmlFor='home-name'>Name</label>
                <input id='home-name' name='name' type='text' placeholder='Your name' required />
              </div>
              <div style={{ flex: 1 }}>
                <label htmlFor='home-email'>Email</label>
                <input id='home-email' name='email' type='email' placeholder='your@email.com' required />
              </div>
            </div>

            <label htmlFor='home-subject'>Subject</label>
            <input id='home-subject' name='subject' type='text' placeholder='What is this about?' required />

            <label htmlFor='home-message'>Message</label>
            <textarea id='home-message' name='message' placeholder='Your message...' required />

            {error && <p style={{ color: '#c00', fontSize: 14, marginBottom: 12 }}>{error}</p>}

            <button type='submit' disabled={sending}>{sending ? 'Sending...' : 'Send Message'}</button>
          </form>
        )}
      </div>

    </div>
  )
}

export default Home
